import { AxiosRequestConfig } from 'axios';

const endpoint = 'api/countries';

export default {
    searchCitiesOfCountry: (id: number, data: { page: number; pageSize: number; text?: string }) =>
        ({ method: 'POST', url: `${endpoint}/${id}/cities`, data } as AxiosRequestConfig),
};
